import {
  UPDATE_ACCOUNT_FEATURES,
  CLEAR_ACCOUNT_DATA,
} from 'constants/actionTypes';
import {
  EDITOR_PERMISSIONS_ROLE,
  FREQUENCY_BUFFER,
  WIDGET_TARGETING,
  EXTRA_CHECKLIST_CUSTOMIZATION,
  EVENT_TRIGGERING,
  EVENT_ATTRIBUTE_TRIGGERING,
  MULTI_APP_ENABLED,
  NPS_RANGE_SM,
  NPS_RANGE_MED,
  NPS_RANGE_LG,
} from 'constants/features';

const initialState = {
  synced: false,
  features: {
    [EDITOR_PERMISSIONS_ROLE]: false,
    [FREQUENCY_BUFFER]: false,
    [WIDGET_TARGETING]: false,
    [EXTRA_CHECKLIST_CUSTOMIZATION]: false,
    [EVENT_TRIGGERING]: false,
    [EVENT_ATTRIBUTE_TRIGGERING]: false,
    [MULTI_APP_ENABLED]: false,
    [NPS_RANGE_SM]: false,
    [NPS_RANGE_MED]: false,
    [NPS_RANGE_LG]: false,
  },
};

export default function features(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ACCOUNT_FEATURES:
      return {
        synced: true,
        features: {
          ...state.features,
          ...action.payload,
        },
      };
    case CLEAR_ACCOUNT_DATA:
      return initialState;
    default:
      return state;
  }
}

export const selectAccountFeaturesSynced = state =>
  state.account.features.synced;

export const selectAccountFeatures = state =>
  state?.account?.features?.features;

export const selectAccountFeature = (state, feature) => {
  const accountFeatures = selectAccountFeatures(state);

  return Boolean(accountFeatures?.[feature]);
};
